import { createSelector } from 'reselect';
import { updateReadyToCheckoutSelector } from 'selectors/testTarget/offers/updateReadyToCheckout/updateReadyToCheckoutSelector';

const showSelector = createSelector(updateReadyToCheckoutSelector, updateReadyToCheckout => !!updateReadyToCheckout.show);

export { showSelector };
